import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatStepper } from '@angular/material';
import { MasterService } from 'src/app/services/master.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AccountService } from 'src/app/services/account.service';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { Basic } from 'src/app/core/models/basic.model';
import { ComplaintSubReason } from 'src/app/models/master/complaint-sub-reason.model';
import { BillService } from 'src/app/services/bill.service';
import { BillItem } from 'src/app/models/bill/bill-item.model';
import { Complaint } from 'src/app/models/complaint/complaint.model';
import { CheckableItem } from 'src/app/core/models/checkable-item.model';
import { ComplaintClient } from 'src/app/models/complaint/complaint-client.model';
import { ComplaintAddress } from 'src/app/models/complaint/complaint-address.model';
import { ComplaintSimpleAddress } from 'src/app/models/complaint/complaint-simple-address.model';
import { ComplaintClientRepresentative } from 'src/app/models/complaint/complaint-client-representative.model';
import { ComplaintBill } from 'src/app/models/complaint/complaint-bill.model';
import { Email } from 'src/app/core/models/email.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { MeterContrastAdComponent } from '../meter-contrast-ad/meter-contrast-ad.component';
import Swal from 'sweetalert2';
import { ComplaintService } from 'src/app/services/complaint.service';
import { ComplaintResponseComponent } from 'src/app/components/complaint-response/complaint-response.component';
import { NotificationAddressSectionComponent } from '../notification-address-section/notification-address-section.component';
import { ClientSectionComponent } from '../client-section/client-section.component';
import { ClientAddressSectionComponent } from '../client-address-section/client-address-section.component';
import { ClientRepresentativeSectionComponent } from '../client-representative-section/client-representative-section.component';
import { Router } from '@angular/router';
import { EmailNotification } from 'src/app/models/complaint/complaint-email-notification.model';
import { EnvironmentService } from 'src/app/core/services/environment.service';
//import { MeterContrastAd2Component } from '../meter-contrast-ad2/meter-contrast-ad2.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailValidatorService } from 'src/app/services/email-validator.service';
import { ClaimsBlocking } from 'src/app/models/complaint/ClaimsBlocking.model';
import { ComplaintConcept } from 'src/app/models/complaint/complaint-concept.model';
import * as moment from 'moment/moment';
import { ComplaintAndMetereadingService } from 'src/app/services/complaint-and-metereading.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { BackOfficeService } from 'src/app/services/back-office.service';
import { MeterReciboDigitalComponent } from '../meter-recibo-digital/meter-recibo-digital.component';

@Component({
  selector: 'app-complaint',
  templateUrl: './complaint.component.html',
  styleUrls: ['./complaint.component.scss']
})
export class ComplaintComponent implements OnInit {
  /*Lista de meses disponibles */
  monthList: Basic<string>[] = [{ code: '01', description: 'Enero' },
  { code: '02', description: 'Febrero' },
  { code: '03', description: 'Marzo' },
  { code: '04', description: 'Abril' },
  { code: '05', description: 'Mayo' },
  { code: '06', description: 'Junio' },
  { code: '07', description: 'Julio' },
  { code: '08', description: 'Agosto' },
  { code: '09', description: 'Septiembre' },
  { code: '10', description: 'Octubre' },
  { code: '11', description: 'Noviembre' },
  { code: '12', description: 'Diciembre' }];
  /*Lista de aí±os disponibles */
  availableYearList: Basic<string>[] = [];
  /*Lista de motivos */
  reasonList: Basic<string>[] = [];
  /*Lista de submotivos */
  subReasonList: ComplaintSubReason[] = [];
  /*Lista de items del recibo seleccionado */
  billItemList: CheckableItem<BillItem>[] = [];
  /*Lista de códigos de submotivos que emplean la sección de recibos */
  billSubReasonCodeList: string[] = ['Z014', 'Z015', 'Z016', 'Z018', 'Z019', 'Z020', 'Z023'];

  /*Es cliente? */
  public isClient = false;
  public emailUser: string;
  public notifyMessage: string;
  public back: boolean;
  public send: boolean;
  activaGuardar: string;
  public isLinear = false;
  public isCompleted = false;
  public emailValidList: any = [];
  public emailValid: string;
  public blockingList: any = [];
  public conceptList: any = [];
  public checkBoxList: any = [];
  public statusValues: any = [];
  public ammountList: any = [];
  public difRoundedList: any = [];
  public totalSum: any;
  public importSum: any;
  public finalSum: any;
  public arraySum: any;
  public consolidateClaim: boolean = true;
  public registerNewClaim: boolean = true;
  public searchActivated: boolean = true;
  public desactivateConsolidate: boolean = true;
  public statusCheckBoxList: boolean = false;
  public hideNextButton: boolean = true;
  public messageNotificationIcon: boolean = true;
  public showClientRepresentative: boolean = false;
  public iconDescription: boolean = true;
  public listToView: any = [];
  public listToSend: any = [];

  //public importElementsSelected: any = [];
  public urlAWS: any;
  /* Descripcion temporal hasta obtener la lista del serivicio*/
  public reasonCode: string;
  public subReasonCode: string;
  public reasonDescCode: string;
  public subReasonDescCode: string;
  public descriptionCode: string;
  public reasonName: string;
  public suReasonName: string;
  public billData: boolean;
  public emDate: any;
  public billModal: any;
  public fileNotification: any;
  public emailModal: any;
  public docTypeSession: any;
  public docTypeNoClient: any;
  public finalImport: any;
  adjuntosevi: File = undefined;

  NotiGroup: FormGroup;
  public reasonNameList: Array<any> = [
    { code: 'G002', description: 'El contrato de suministro' },
    { code: 'G003', description: 'Corte y reconexión del servicio' },
    { code: 'G004', description: 'La facturación de mi recibo' },
    { code: 'G006', description: 'La habilitación del servicio de gas' },
    { code: 'G001', description: 'El medidor' },
    { code: 'G007', description: 'Las obras externas o el desmonte' },
    { code: 'G008', description: 'La obtención del suministro' },
    { code: 'G005', description: 'La deuda o el pago' },
  ];
  public subReasonNameList: Array<any> = [
    { code: 'Z001', description: 'Tengo problemas con la caja de mi medidor (Tapa caí­da, tapa abierta, visor caí­do, etc).' },
    { code: 'Z002', description: 'Tengo problemas con la ubicación de mi medidor (El medidor afecta al vecino,  dificulta la modificación del predio, etc).' },
    { code: 'Z003', description: 'Tengo problemas con mi medidor (Contómetro no gira, números de contómetro tienen problemas al girar).' },
    { code: 'Z004', description: 'Aprobaron mi contrato y no se volvieron a contactar/Hubo cambios en las condiciones iniciales del contrato.' },
    { code: 'Z005', description: 'Me cortaron el servicio sin tener deuda actual.' },
    { code: 'Z006', description: 'Me cortaron el servicio en mi revisión quinquenal por equivocación.' },
    { code: 'Z007', description: 'He solicitado la reconexión de mi servicio luego de mi solicitud de suspensión de servicio.' },
    { code: 'Z008', description: 'Ya pagué mi deuda y no han reconectado mi servicio.' },
    { code: 'Z009', description: 'Aún no reconectan mi servicio después de una revisión quinquenal o emergencia.' },
    { code: 'Z010', description: 'Aún no suspenden el servicio de gas natural que solicité.' },
    { code: 'Z011', description: 'Aún no realizan el retiro de mi medidor y tuberí­a de conexión.' },
    { code: 'Z012', description: 'Aún no realizan el retiro de mi medidor.' },
    { code: 'Z013', description: 'Aún no realizan el retiro de mi tuberí­a de conexión.' },
    { code: 'Z014', description: 'No estoy de acuerdo con el cobro/monto de facturación de cargos fijos (Transporte y distribución y/o categorí­a tarifaria).' },
    { code: 'Z015', description: 'No estoy de acuerdo con el cobro/monto del corte y reconexión por mantenimiento quinquenal.' },
    { code: 'Z016', description: 'No estoy de acuerdo con el cobro/monto del corte y reconexión del servicio.' },
    { code: 'Z017', description: 'El recibo demora en llegar / No me ha llegado mi recibo.' },
    { code: 'Z018', description: 'He verificado mi medidor y el consumo es cercano a la "Lectura actual" de mi recibo, pero me parece elevado.' },
    { code: 'Z019', description: 'No estoy de acuerdo con el cobro/monto del financiamiento Bonogas.' },
    { code: 'Z020', description: 'He verificado mi medidor y el consumo es menor a la "Lectura actual" de mi recibo.' },
    { code: 'Z021', description: 'Vivo en otro predio y le llega una carta o aviso a otra persona.' },
    { code: 'Z022', description: 'Pagué mi deuda y me llegó carta o aviso de corte de servicio.' },
    { code: 'Z023', description: 'No visualizo mi pago/ lo veo duplicado.' },
    { code: 'Z024', description: 'Hay redes externas en la calle donde vivo y se están demorando en  habilitar mi servicio .' },
    { code: 'Z025', description: 'No hay redes externas en la calle donde vivo y se están demorando en habilitar mi servicio.' },
    { code: 'Z026', description: 'Solicito la conexión pendiente de mi artefacto y se están demorando en atenderla.' },
    { code: 'Z027', description: 'La construcción de redes externas para el Gas natural ha afectado otros servicios públicos.' },
    { code: 'Z028', description: 'Mal acabado o demora en la reparación de la pista.' },
    { code: 'Z029', description: 'Han dejado desmonte en la ví­a pública.' },
    { code: 'Z033', description: 'El recorrido de redes externas están afectandome.' },
    { code: 'Z034', description: 'Se están demorando en la respuesta a la solicitud de factibilidad de suministro.' },
    { code: 'Z035', description: 'No estoy de acuerdo con el resultado de solicitud de factibilidad de suministro.' },
    { code: 'Z036', description: 'Firmé mi contrato de suministro de Gas natural y aún no ha sido aprobado.' }
  ];

  aceptaCorreo: string;
  /*Mostrar sección de recibo? */
  showBillSection = false;
  /*Suscripción a observable de cuenta seleccionada */
  accountSelectedSubscription: Subscription;

  contrastConfirm: boolean;

  isContrast: string;

  isEmailNotificaction: string;

  typeClient2: string;
  bandera: boolean;
  accountCode: string;
  flagOV: string;

  isErrorBasicData: boolean = false;

  isAcceptTerms: boolean = false;

  clientFlagPrivacyWebPolitic: string;

  @ViewChild('clientSectionComponent', { read: ClientSectionComponent, static: false })
  public clientSectionComponent: ClientSectionComponent;
  @ViewChild('clientAddressSectionComponent', { read: ClientAddressSectionComponent, static: false })
  public clientAddressSectionComponent: ClientAddressSectionComponent;
  @ViewChild('clientRepresentativeSectionComponent', { read: ClientRepresentativeSectionComponent, static: false })
  public clientRepresentativeSectionComponent: ClientRepresentativeSectionComponent;
  @ViewChild('notificationAddressSectionComponent', { read: NotificationAddressSectionComponent, static: false })
  public notificationAddressSectionComponent: NotificationAddressSectionComponent;

  isMensaje6: boolean = false;

  formGroup: FormGroup;
  public secondFormGroup: FormGroup;
  public tercerFormGroup: FormGroup;
  constructor(public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private masterService: MasterService,
    private accountService: AccountService,
    private commonService: CommonService,
    private billService: BillService,
    private authService: AuthService,
    private router: Router,
    private matDialog: MatDialog,
    private modal: NgbModal,
    private complaintService: ComplaintService,
    private environmentService: EnvironmentService,
    private emailValidatorService: EmailValidatorService,
    private complaintandMeterReading: ComplaintAndMetereadingService,
    private spinner: SpinnerVisibilityService,
    private backOfficeService: BackOfficeService) {
    this.accountSelectedSubscription = this.commonService.accountSelectedAnnounced.subscribe(account => {
      this.accountCode = account.clientCode

      this.getBasicData(this.accountCode);
    });
  }

  ngOnInit() {
    if (this.authService.getAuthToken() && !this.authService.checkIfItIsInsideIframe()) {
      this.isClient = true;
    }
    else {
      this.isClient = false;
    }
    this.bandera = this.accountService.getBandera();
    if (this.bandera == false && this.authService.IsStandaloneModule()) {
      this.isClient = false;
    }

    //  this.statusEditAmmount.forEach(element => {
    //   element = true;

    // }); 
    let email = window.localStorage.getItem('userEmail');

    window.localStorage.removeItem('operationIdGenerate');
    this.NotiGroup = this.formBuilder.group({
      AceptaOki: ['', Validators.required]
    });
    //if (this.authService.getAuthToken() && this.authService.checkIfItIsInsideIframe()) this.isClient = true;
    this.createForm();
    // this.dialog.open(ComplaintTopicComponent, {
    //   disableClose: true
    // });
    this.listComplaintReasons();
    this.fillYearList();
    this.back = false;
    this.send = false;
    this.secondFormGroup = this.formBuilder.group({
      reason: ['', Validators.required],
      subReason: ['', Validators.required],
      // subReasonDesc: ['', Validators.required],
      description: ['', [Validators.required, Validators.maxLength(550)]]
    });

    this.isLinear = true;
    this.isCompleted = false;
    this.billData = true;
    // this.reasonCode = '';
    // this.subReasonCode = '';
    // this.subReasonDescCode = '';
    // this.descriptionCode = '';
    this.bandera = this.accountService.getBandera();
    //  this.statusEditAmmount.forEach(element => {
    //   element = true;

    // }); 
    //let email = window.localStorage.getItem('userEmail');   

    //VALIDAR mensajeria
    this.backOfficeService.getMensajeAlerta("6").then(p => {
      this.isMensaje6 = (p as any).activo;
    });


  }

  ngOnDestroy() {
    this.accountSelectedSubscription.unsubscribe();
  }
  ngAfterViewInit() {
    // let flag = window.localStorage.getItem('flagOV');
    // console.log("Flag actual",flag)

    // this.deleteCookies();
    // if(this.isClient != true && this.authService.IsStandaloneModule())
    // {
    //   let flag = window.localStorage.getItem('token');
    //   if(flag!= null)
    //   {
    //     window.location.href = window.location.href;
    //   }
    //   window.localStorage.removeItem('token');
    // }

    //window.localStorage.removeItem('flagOV');

    if (!this.isClient) {
      this.addOtherFormControls();

    }
  }
  createForm() {
    this.formGroup = this.formBuilder.group({
      reason: [, [Validators.required]],
      subReason: [, [Validators.required]],
      // subReasonDesc: [, [Validators.required]],
      description: [, [Validators.required, Validators.maxLength(550)]],
      bill: this.formBuilder.group({
        number: [{ value: '', disabled: true }],
        month: [],
        year: []
      })
    });
  }
  get f() { return this.formGroup.controls; }


  fillYearList() {
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 7; i++) {
      this.availableYearList.push({ code: (currentYear - i).toString(), description: (currentYear - i).toString() });
    }
  }

  listComplaintReasons() {
    this.masterService.listComplaintReasons().subscribe(response => {

      this.reasonList = response.data;
      if (!this.isClient) {
        let noClientComplaintList = ["G007", "G008"];
        this.reasonList = this.reasonList.filter(x => noClientComplaintList.includes(x.code));
      }
      this.reasonList.sort((a, b) => {
        const descriptionA = a.description.toLowerCase(), descriptionB = b.description.toLowerCase();
        if (descriptionA < descriptionB) { return -1; } else if (descriptionA > descriptionB) { return 1; } else { return 0; }
      });
    });

  }

  listComplaintSubReason() {
    this.suReasonName = "";
    this.masterService.listComplaintSubReasons(this.formGroup.get('reason').value).subscribe(response => {
      //Validación de lista de submotivos para no clientes
      if (this.isClient == false) {
        this.subReasonList = response.data;

        //Validación para no cliente

        const newSubReasonList = [];
        for (var item of this.subReasonList) {
          if (item.code == "Z032") {
            newSubReasonList.push(item);
          }
        }
        var obrasexternas = this.subReasonList.find(x => x.code == "Z032")

        if (obrasexternas != null) {
          this.subReasonList = newSubReasonList
        }
        else {
          this.subReasonList = response.data
        }

      }
      //console.log("Lista de submotivos",this.subReasonList)
      //this.subReasonList = response.data;

      this.masterService.listComplaintSubReasons(this.formGroup.get('reason').value).subscribe(response => {
        //VALIDAR mensajeria
        this.subReasonList = response.data;
        this.subReasonList.sort((a, b) => {
          const descriptionA = a.description.toLowerCase(), descriptionB = b.description.toLowerCase();
          if (descriptionA < descriptionB) { return -1; } else if (descriptionA > descriptionB) { return 1; } else { return 0; }
        });
        this.formGroup.get('subReason').patchValue(null);
        this.showBillSection = false;
        this.cleanBillSection();
      });
      //Descripciones del motivo y submotivo
      //this.reasonDescCode = this.reasonCode;
      //let reasonN = this.reasonNameList.find(x => x.code == this.reasonDescCode);

      //this.reasonName = reasonN.description;
    });

  }

  async correo() {
    this.spinner.show();
    if (this.isClient == false) {
      this.emailModal = this.formGroup.get('client').get('email').value;
    }
    var regex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    Swal.fire({
      title: 'Correo de notificación',
      input: 'text',
      inputValue: this.emailModal,
      showCancelButton: true,
      cancelButtonColor: "#F44336",
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
      confirmButtonColor: "#00a1de ",
      inputPlaceholder: "Correo para la notificación",
      allowOutsideClick: false
    }).then((result) => {
      if (result.value) {
        if (regex.test(result.value) == false) {
          // this.spinner.hide();
          this.messageNotificationIcon = true;
          Swal.fire(
            {
              title: 'Correo de notificación',
              text: 'Correo electrónico inválido',
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#00A1DE',
              confirmButtonText: 'Continuar',
              allowOutsideClick: false
            })
          return false;
        }
        else if (regex.test(result.value) == true) {
          this.emailUser = result.value;
          let reponse = this.validateEmail(this.emailUser);
          this.notifyMessage = "Se le notificará electrónicamente al correo registrado";
          // this.spinner.hide();
          if (this.isClient == true) {
            this.back = true;
            this.send = false;
            this.hideNextButton = true;
          }
          else {
            this.back = true;
            this.send = true;
            this.hideNextButton = false;
          }
          this.messageNotificationIcon = false;
          this.emailUser = result.value;
        }
      }
      else {
        //this.onItemChange('NO');
        var acepta = document.getElementById('inlineRadio1');
        var noAcepta = document.getElementById('inlineRadio2');
        this.messageNotificationIcon = true;
        // this.spinner.hide();
        Swal.fire(
          {
            title: 'Correo de notificación',
            text: 'Por favor ingrese su correo electrónico',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#00A1DE',
            confirmButtonText: 'Continuar',
            allowOutsideClick: false
          })
        this.spinner.hide();
        return false
      }
    })
  }

  async evaluateEmail(email, valid) {
    var regex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    if (valid == null) {
      this.messageNotificationIcon = true;
      Swal.fire(
        {
          title: 'Correo de notificación',
          text: 'Ha ocurrido un error. Contácte a soporte por favor.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      this.spinner.hide();
      return true;
    }
    else if (valid == "false") {
      this.messageNotificationIcon = true;
      Swal.fire(
        {
          title: 'Correo de notificación',
          icon: 'warning',
          text: 'El correo ingresado no es válido',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      this.spinner.hide();
      return false;
    }
    else if (regex.test(email) == true && this.emailValid == "true") {

      this.notifyMessage = "Se le notificará electrónicamente al correo registrado";
      this.back = true;
      this.send = false;
      this.emailUser = email;
      this.hideNextButton = true;
      this.messageNotificationIcon = false;
      Swal.fire(
        {
          title: 'Correo de notificación',
          text: 'Se registró correctamente el correo electrónico',
          icon: 'success',
          html: '<b>' + this.emailUser + '</b>',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      this.spinner.hide();
      return true;
    }

  }

  async validateEmail(data: any) {
    this.emailValidatorService.emailValidate(data).subscribe(
      response => {
        let data = response;

        this.emailValid = data.validMailbox;

        this.evaluateEmail(data.to, this.emailValid)
        // this.spinner.hide();
      },
      err => {
        Swal.fire({
          title: "Error de servicio",
          text: "Respuesta con error del servicio de correo",
          icon: 'info',
          allowOutsideClick: false
        });
        this.spinner.hide();
        return false
      });

  }

  showEmail() {
    if (this.emailUser != '') {
      Swal.fire({
        title: "Correo registrado",
        html: '<b>' + this.emailUser + '</b>',
        icon: 'info',
        allowOutsideClick: false
      });
      return

    }
    else {
      return
    }
  }

  cambiarNo() {
    this.aceptaCorreo = 'NO';
    this.back = false;
    this.send = false;
    this.hideNextButton = false;
    this.emailUser = undefined;
    this.emailModal = undefined;
    this.messageNotificationIcon = true;
    this.typeClient2 = this.accountService.getTypeClient();

  }

  SteppControl(value, stepper: MatStepper) {

    if (value == '99') {
      this.send = true;
      var empty = null;
      if (this.isClient == false && this.aceptaCorreo == 'SI') {
        this.isCompleted = true;
        stepper.next();
        return;
      }
      else {
        if (this.notificationAddressSectionComponent.formGroup.get('firstNotificationAddress').valid) {
          this.isCompleted = true;
          stepper.next();
          return;
        } else {
          this.notificationAddressSectionComponent.formGroup.markAllAsTouched();
        }
      }


    }
    if (value == '4') {
      this.send = true;
      if (this.activaGuardar == '4') {
        if (this.isClient == false) {
          //VALIDACION NECRO

          if (this.clientSectionComponent.formGroup.valid) {
            this.isCompleted = true;
            stepper.next();
            return;
          } else {
            this.clientSectionComponent.formGroup.markAllAsTouched();
          }


        } else {

          if (this.clientSectionComponent.formGroup.valid) {
            this.isCompleted = true;
            stepper.next();
            return;
          } else {
            this.clientSectionComponent.formGroup.markAllAsTouched();
          }

        }

      }
      else {
        this.back = false;
        if (this.isClient == false && this.aceptaCorreo == 'SI') {
          stepper.previous();
          stepper.previous();
        }
        else {

          if (this.docTypeSession == "Z004" && this.isClient == true || this.docTypeNoClient == "Z004" && this.isClient == false) {
            stepper.previous();
          }
          else {
            stepper.previous();
            stepper.previous();
          }
        }
      }
    }
    else if (value == "0") {
      if (this.docTypeSession == "PE1" && this.isClient == true || this.docTypeNoClient == "PE1" && this.isClient == false) {
        stepper.previous();
      }
      else {
        stepper.previous();
        //stepper.previous();
      }
    }
    else if (value == '2') {
      this.send = true;
      var empty = null;
      if (this.isClient == false) {
        if (this.clientSectionComponent.formGroup.valid) {
          //Validación para pasar a la otra sección
          this.docTypeNoClient = this.formGroup.get('client').get('documentType').value;
          //console.log("TIPO DE DOC - NO CLIENTE", this.docTypeNoClient)
          if (this.docTypeNoClient == "Z004") {
            this.isCompleted = true;
            stepper.next();
            return;
          }
          else {
            stepper.next();
            stepper.next();
          }

        } else {
          this.clientSectionComponent.formGroup.markAllAsTouched();
        }

      }
      else {
        if (this.docTypeSession == "PE1" && this.isClient == true) {
          this.isCompleted = true;
          stepper.next();
        }
        else {
          stepper.next();
          //stepper.next();
        }
      }
    }
    else if (value == '7') {
      if (this.clientRepresentativeSectionComponent.formGroup.valid) {
        this.isCompleted = true;
        stepper.next();
        return;

      }
      else {
        this.clientRepresentativeSectionComponent.formGroup.markAllAsTouched();
      }

    }
    else if (value == '9') {
      //   let reasonSelected = this.formGroup.get('reason').value;
      //  console.log("reasonSelected",reasonSelected )     
      var empty = null;

      if (this.emailUser != undefined && this.isClient == true) {
        this.send = false;
        this.hideNextButton = true;
        this.messageNotificationIcon = false;
      }
      else {
        this.send = true;
        this.hideNextButton = true;
        this.messageNotificationIcon = true;
      }
      if (this.isClient == false && this.emailUser != undefined) {
        this.send = true;
        this.hideNextButton = false;
        this.messageNotificationIcon = false;
      }

      if (this.aceptaCorreo == "NO") {
        this.hideNextButton = false;

      }
      if (this.aceptaCorreo == "SI" && this.emailModal != "") {
        this.send = false;
        this.hideNextButton = true;
        this.messageNotificationIcon = false;
      }
      if (this.aceptaCorreo == "SI" && this.emailModal != "" && this.isClient == false) {
        this.send = true;
        this.hideNextButton = false;
        this.messageNotificationIcon = false;
      }

      if (this.formGroup.get('reason').valid && this.formGroup.get('subReason').valid && this.formGroup.get('description').valid) {

        this.isCompleted = true;
        stepper.next();
        return;
      }
      else {
        this.formGroup.markAllAsTouched();
      }

    }
    else if (value == '5') {
      if (this.clientAddressSectionComponent.formGroup.valid) {
        this.isCompleted = true;
        this.clientAddressSectionComponent.concatStreetAddress();
        this.formGroup.get('notificationAddress').patchValue({
          firstNotificationAddress: this.clientAddressSectionComponent.ConcatAdress.substring(0, 60)
        });

        // complaint.firstNotificationAddress = this.clientAddressSectionComponent.ConcatAdress;
        stepper.next();
        return;
      } else {
        this.clientAddressSectionComponent.formGroup.markAllAsTouched();
      }

    }
    else if (value == '3') {

      if (this.aceptaCorreo != empty && this.aceptaCorreo != '' && this.aceptaCorreo != null) {
        if (this.isEmailNotificaction) {
          this.send = false;
        }
        if (this.isClient == false && this.aceptaCorreo == 'SI') {
          stepper.next();
          stepper.next();
        }
        else {
          stepper.next();
        }
      }
    }
  }

  subReasonChanged() {
    this.showBillSection = this.billSubReasonCodeList.includes(this.formGroup.get('subReason').value);
    this.searchActivated = true;
    if (this.showBillSection) {
      this.cleanBillSection();
      this.formGroup.get('bill').get('number').setValidators(Validators.required);
      this.formGroup.get('bill').get('month').setValidators(Validators.required);
      this.formGroup.get('bill').get('year').setValidators(Validators.required);
      this.formGroup.updateValueAndValidity();
    } else {
      this.formGroup.get('bill').get('number').setValidators(null);
      this.formGroup.get('bill').get('month').setValidators(null);
      this.formGroup.get('bill').get('year').setValidators(null);
    }
    this.formGroup.get('bill').get('number').updateValueAndValidity();
    this.formGroup.get('bill').get('month').updateValueAndValidity();
    this.formGroup.get('bill').get('year').updateValueAndValidity();
    //Descripciones del motivo y submotivo
    this.subReasonDescCode = this.subReasonCode;
    let subReasonN = this.subReasonNameList.find(x => x.code == this.subReasonDescCode);

    if (subReasonN != null) {
      this.suReasonName = subReasonN.description;
      this.iconDescription = false;
    }
    else {
      this.suReasonName = '';
      this.iconDescription = true;
    }

    if ((this.formGroup.get('subReason').value == "Z018" || this.formGroup.get('subReason').value == "Z020")) {


      const meterReciboDigital = this.matDialog.open(MeterReciboDigitalComponent, {
        disableClose: true,
        width: '878px', // Ancho del diálogo
        height: '1130px', // Alto del diálogo
      });
      meterReciboDigital.afterClosed().subscribe(response => {

        const meterContrastAd = this.matDialog.open(MeterContrastAdComponent, {
          disableClose: true
        });
        meterContrastAd.afterClosed().subscribe(response => {
          this.contrastConfirm = response;
        });

      })

    }

  }

  cleanBillSection() {
    this.formGroup.get('bill').patchValue({
      number: null,
      month: null,
      year: null
    });
    this.billItemList = [];
  }
  getDetailedBill() {

    if (this.formGroup.get('bill').get('month').value != null && this.formGroup.get('bill').get('year').value != null) {
      this.billService.getDetailedBill(this.formGroup.get('client').get('code').value,
        this.formGroup.get('bill').get('month').value,
        this.formGroup.get('bill').get('year').value,
      ).subscribe(response => {

        if (response.valid) {
          this.billItemList = response.data.itemList.map((item => new CheckableItem<BillItem>(item)));
          this.formGroup.get('bill').get('number').patchValue(response.data.number);
          this.searchActivated = false;
        }
        else if (response.valid && response.warning) {
          this.billItemList = [];
          this.formGroup.get('bill').get('number').patchValue(null);
          Swal.fire('Información', response.message, 'warning');
          this.searchActivated = true;
        }
        else {
          this.billItemList = [];
          this.formGroup.get('bill').get('number').patchValue(null);
        }
      });
    }
  }

  addOtherFormControls() {
    this.formGroup.addControl('client', this.clientSectionComponent.formGroup);
    this.formGroup.addControl('notificationAddress', this.notificationAddressSectionComponent.formGroup);
    this.formGroup.addControl('representative', this.clientRepresentativeSectionComponent.formGroup);
    if (this.isClient == false) {
      this.formGroup.addControl('clientAddress', this.clientAddressSectionComponent.formGroup);
    }
  }

  getBasicData(clientCode: string) {
    this.accountService.getBasicData(clientCode).subscribe(response => {
      if (!response.data.documentNumber || !response.data.name || !response.data.lastName) {
        Swal.fire({
          title: "Error de servicio",
          text: "Por favor intentelo mas tarde",
          icon: 'info',
          allowOutsideClick: false
        });
        this.isErrorBasicData = true;
      }
      this.addOtherFormControls();
      this.clientSectionComponent.fillForm(response.data);
      //console.log("Datos de la cuenta", response)
      //"PE1" RUC
      if (this.isClient == true) {
        this.docTypeSession = response.data.documentType
        //this.docTypeSession = "PE1"
        //console.log("tipo de documento", this.docTypeSession)        
      }
      if (this.isClient == true && this.accountService.getTypeClient() == 'RES' ||
        this.isClient == true && this.accountService.getTypeClient() == 'COM') {
        //Correo de actualización de datos

        //Correo de ingreso
        let emailSaved = window.localStorage.getItem('appEmail');
        console.log("Correo obtenido de la sesión", emailSaved)
        if (this.bandera == false && !this.authService.IsStandaloneModule()) {
          this.emailModal = response.data.emailAddress;
          console.log("Correo de actualizacion de datos", this.emailModal)
          if (this.emailModal == null || this.emailModal == "") {
            this.emailModal = emailSaved;
          }
        }
        else {
          this.emailModal = "";
        }
      }
      else {
        this.emailModal = "";
      }
      this.notificationAddressSectionComponent.fillForm(response.data);
      if (this.isClient == false) {
        this.clientAddressSectionComponent.fillForm(response.data);
      }
      this.cleanBillSection();
    });
  }
  onItemChange(value) {
    this.emailUser = undefined;
    this.notifyMessage = undefined;
    this.back = false;
    this.aceptaCorreo = value;
    //console.log("aceptacorreo", this.aceptaCorreo)
    if (this.aceptaCorreo == 'SI') {

      this.send = true;
      this.isEmailNotificaction = "SI"
      this.hideNextButton = true;
      if (this.emailUser != '') {
        this.messageNotificationIcon = false;
      }
      else {
        this.messageNotificationIcon = true;
      }

    }
    if (this.aceptaCorreo == "NO") {

      this.isEmailNotificaction = "NO"
      this.hideNextButton = false;
      this.send = true;
      this.messageNotificationIcon = true;

    }

  }
  openModal(contenido) {

    let request = new ClaimsBlocking();
    request.CodMotivo = this.reasonCode;
    request.CodSubMotivo = this.subReasonCode;
    request.PeriodoAnno = this.formGroup.get('bill').get('year').value;
    request.PeriodoMes = this.formGroup.get('bill').get('month').value;
    //request.PeriodoAnno = "2017";
    //request.PeriodoMes = "05";
    request.Interlocutor = "";
    request.Contrato = "";
    request.CtaContrato = this.formGroup.get('client').get('code').value;
    //request.CtaContrato = "640159";
    request.UsuarioServicio = "UsrCalidda2021";
    request.ClaveServicio = "Calidd@2021";
    if (request.PeriodoAnno == null || request.PeriodoMes == null) {
      Swal.fire(
        {
          title: 'Información',
          text: 'Por favor seleccione el mes y el aí±o para la búsqueda',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      return false;
    }
    else {
      if (request) {
        this.complaintService.getInfo(request).subscribe(
          res => {

            this.blockingList = res;
            this.conceptList = this.blockingList.PE_Concepto;

            if (this.conceptList.length != 0) {
              for (let i = 0; i < this.conceptList.length; i++) {
                if (this.conceptList[i].CodConcepto == '08000010') {
                  this.difRoundedList.push(this.conceptList[i]);
                  this.conceptList = this.conceptList.filter(item => item != this.conceptList[i]);
                }
              }
            }

            this.invokeModal(contenido);

            let date = this.blockingList.FechaEmision;
            var anio = String(date).substring(0, 4);
            var mes = String(date).substring(4, 6);
            var dia = String(date).substring(6, 8);
            let nuevaFecha = dia + "/" + mes + "/" + anio;
            let newFormat = moment(nuevaFecha, 'DD/MM/YYYY')
            newFormat.locale('es');
            let newDate = newFormat.format('DD [de] MMMM [del] YYYY');
            this.emDate = newDate
            this.billModal = this.formGroup.get('bill').get('number').value;
            //Para autosumar los importes
            let ImportList: any = [];
            for (let i = 0; i < this.conceptList.length; i++) {
              ImportList.push(parseFloat(this.conceptList[i].Importe))
            }

            let total = ImportList.map(c => parseFloat(c)).reduce((a, b) => a + b, 0.00);
            let rounded = parseFloat(total).toFixed(2);
            this.importSum = rounded;

          },
          err => {
            //console.log("error del servicio de bloqueo de reclamos", err)
          });


      }
    }

  }
  async invokeModal(contenido) {

    if (this.conceptList.length == 0) {
      Swal.fire(
        {
          title: 'Información',
          text: 'No se han encontrado conceptos',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#00A1DE',
          confirmButtonText: 'Continuar',
          allowOutsideClick: false
        })
      return false;
    }
    else {
      this.modal.open(contenido, { size: 'lg' });
    }

  }

  async clearBoxes() {

    for (let i = 0; i < this.ammountList.length; i++) {
      this.ammountList[i] = '';

    }
    this.totalSum = 0.00;


    this.clearCheckBoxes();
    this.consolidateClaim = true;
    this.registerNewClaim = true;
    return false;
  }

  async cleanRows() {

    this.listToView = [];
    this.listToSend = [];
    this.finalImport = 0.00;
  }

  async clearCheckBoxes() {

    for (let i = 0; i < this.checkBoxList.length; i++) {
      this.checkBoxList[i] = false;

    }
  }

  autoSumElements() {

    for (let i = 0; i < this.conceptList.length; i++) {
      //CPAREDES COMPARACION DE CAMPOS
      let saldo = parseFloat(this.conceptList[i].Importe);
      let saldoIniciado = parseFloat(this.ammountList[i]);
      if (saldo < saldoIniciado) {
        Swal.fire(
          {
            title: 'Información',
            text: 'Por favor. Ingresa un valor menor al importe',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#00A1DE',
            confirmButtonText: 'Continuar',
            allowOutsideClick: false
          })
        this.ammountList[i] = "";
        return false;
      }
    }

    for (let i = 0; i < this.ammountList.length; i++) {
      if (this.ammountList[i] == null || this.ammountList[i] == "") this.ammountList[i] = 0.00;
    }

    let total = this.ammountList.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
    let rounded = parseFloat(total).toFixed(2);
    this.totalSum = rounded;
    if (this.totalSum != 0) {
      this.consolidateClaim = false
      this.registerNewClaim = false
    }
    else {
      this.consolidateClaim = true
      this.registerNewClaim = true
    }
  }

  statusBox() {
    //Igualar a cero los valores de las cajas de texto que no tengan valor
    for (let i = 0; i < this.checkBoxList.length; i++) {
      if (this.ammountList[i] == null || this.ammountList[i] == "") this.ammountList[i] = 0.00
      if (this.checkBoxList[i] == false) this.ammountList[i] = 0.00
      for (let i = 0; i < this.checkBoxList.length; i++) {
        if (this.conceptList[i].DesConcepto == 'Reconexión de Servicio' ||
          this.conceptList[i].DesConcepto == 'Desconexión de Servicio') {
          if (this.checkBoxList[i] == false) {
            this.ammountList[i] = 0.00
          }
          else {
            this.ammountList[i] = this.conceptList[i].Importe;
          }
        }
        else {
          //console.log("Se salió xD")
        }
      }
    }
    //Sumar todos los valores de las cajas de texto digitadas
    let tot = this.ammountList.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
    let round = parseFloat(tot).toFixed(2);
    if (round == 'NaN' || round == 'null') {
      round = '0';
    }
    this.totalSum = round;
    if (this.totalSum != "0.00") {
      this.consolidateClaim = false
      this.registerNewClaim = false
    }
    else {
      this.consolidateClaim = true
      this.registerNewClaim = true
    }
  }

  showData(modal) {
    let total = this.ammountList.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
    let rounded = parseFloat(total).toFixed(2);

    modal.dismiss();
    this.billData = false;
    this.finalSum = rounded;
    //Lista para la grilla
    let data: any = {};
    data.date = this.blockingList.FechaEmision;
    data.dateFormat = String(data.date).substring(6, 8) + "/" + String(data.date).substring(4, 6) + "/" + String(data.date).substring(0, 4);
    data.documentNumber = this.blockingList.NroDocumentoOficial;
    data.total = this.finalSum;
    this.listToView.push(data);

    //Para el servicio

    for (let i = 0; i < this.checkBoxList.length; i++) {
      let checked = this.checkBoxList[i];
      if (checked == true) {
        let data: any = {};
        data.Locutor = this.blockingList.InterloculorComercial;
        data.documentNumber = this.blockingList.NroDocumentoOficial;
        data.Year = this.blockingList.PE_Concepto[i].AñoEjercicio;
        data.Month = this.blockingList.PE_Concepto[i].Mes;
        data.Date = this.blockingList.FechaEmision;
        data.DateHist = this.blockingList.FechaVencimiento;
        data.ConceptCode = this.blockingList.PE_Concepto[i].CodConcepto;
        data.DesConcept = this.blockingList.PE_Concepto[i].DesConcepto;
        data.Import = this.ammountList[i];
        data.Moneda = this.blockingList.PE_Concepto[i].Moneda;
        this.listToSend.push(data);
      }

      // if (this.formGroup.get('subReason').value == "Z018" || this.formGroup.get('subReason').value == "Z065" ||
      // this.formGroup.get('subReason').value == "Z015" || this.formGroup.get('subReason').value == "Z016" ||
      // this.formGroup.get('subReason').value == "Z014" || this.formGroup.get('subReason').value == "Z019" ||this.formGroup.get('subReason').value == "Z020")
      // {
      //   let round: any = {};
      //   round.Locutor = this.blockingList.InterloculorComercial;
      //   round.documentNumber = this.blockingList.NroDocumentoOficial;
      //   round.Year = this.formGroup.get('bill').get('year').value;
      //   round.Month = this.formGroup.get('bill').get('month').value;
      //   round.Date = this.blockingList.FechaEmision;
      //   round.DateHist = this.blockingList.FechaVencimiento;
      //   round.ConceptCode = this.blockingList.PE_Concepto[i].CodConcepto;
      //   round.DesConcept = this.blockingList.PE_Concepto[i].DesConcepto;
      //   round.Import = 0.02;
      //   this.listToSend.push(round);
      //   console.log("Se insertó el concepto adicional")
      // }
      // else
      // {
      //   console.log("no se insertó el parámetro adicional")
      // }
    }
    if (this.formGroup.get('subReason').value == "Z018" ||
      this.formGroup.get('subReason').value == "Z015" || this.formGroup.get('subReason').value == "Z016" ||
      this.formGroup.get('subReason').value == "Z014" || this.formGroup.get('subReason').value == "Z019" || this.formGroup.get('subReason').value == "Z020") {
      for (let i = 0; i < this.difRoundedList.length; i++) {
        let roundedData: any = {};
        roundedData.Locutor = this.blockingList.InterloculorComercial;
        roundedData.documentNumber = this.blockingList.NroDocumentoOficial;
        roundedData.Year = this.formGroup.get('bill').get('year').value;
        roundedData.Month = this.formGroup.get('bill').get('month').value;
        roundedData.Date = this.blockingList.FechaEmision;
        roundedData.DateHist = this.blockingList.FechaVencimiento;
        roundedData.ConceptCode = this.difRoundedList[i].CodConcepto;
        roundedData.DesConcept = this.difRoundedList[i].DesConcepto;
        roundedData.Import = this.difRoundedList[i].Importe;
        roundedData.Moneda = this.difRoundedList[i].Moneda;
        //  roundedDate.Import = parseFloat(this.difRoundedList[i].Importe).toFixed(2)
        //console.log("List para enviar al back", this.listToSend)
        this.listToSend.push(roundedData)
        //console.log("Lista para enviar con el redondeo",this.listToSend) 

      }
    }

    let importFin: any = [];
    for (let i = 0; i < this.listToView.length; i++) {
      importFin.push(this.listToView[i].total)
    }
    let LastSumImport = importFin.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
    let importFinalRounded = parseFloat(LastSumImport).toFixed(2);

    this.finalImport = importFinalRounded;
    this.difRoundedList = [];
    this.checkBoxList = [];
    this.clearBoxes();
    //this.finalSum = this.totalSum;
  }

  closeModal(modal) {
    modal.dismiss();
    this.clearBoxes();
    this.difRoundedList = [];
    this.checkBoxList = [];
  }

  conectToMeterReadingPage() {

    let tokenGenerate = this.complaintandMeterReading.generateToken(this.accountCode);
    window.localStorage.removeItem('tokenGenerate');
    window.localStorage.setItem('tokenGenerate', tokenGenerate);
    if (tokenGenerate) {
      let url = '/frontov/ofivirtual/registrar-lectura';
      window.open(url, '_blank');
    }
  }

  async prepare() {
    var regex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

    if (this.formGroup.valid || this.formGroup.valid == false && this.send == false) {
      Swal.fire({
        title: 'Aviso',
        text: '¿Está seguro de registrar el reclamo con los datos ingresados?',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Enviar',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false
      }).then(async (result) => {
        if (result.value) {
          const complaint = this.buildComplaintObject();
          // if (this.isClient && this.showBillSection) {
          //   const meterContrastAd = this.matDialog.open(MeterContrastAdComponent, {
          //     disableClose: true
          //   });
          //   meterContrastAd.afterClosed().subscribe(response => {
          //     complaint.requestMeterContrast = response;
          //     this.add(complaint);
          //   });
          // }
          // else {

          if (this.adjuntosevi != undefined) {
            this.complaintService.addFileComplaints({
              ClientCode: complaint.client.code,
              fileName: this.adjuntosevi.name,
              Base64Image: (await this.toBase64(this.adjuntosevi) as string)
            }).subscribe(
              response => {

                this.urlAWS = response.data.urlAmazon;
                if (this.urlAWS != null) {
                  complaint.description += " - URLEvidencia: " + this.urlAWS;
                }

                this.add(complaint);
              },
              error => {
                //console.log("Error servicio AWS", error)
              }

            );
          }
          else {
            this.add(complaint);
          }
          // }
        }
      }
      );
    }
    else {
      this.formGroup.markAllAsTouched();
      const errorHtml = await this.commonService.buildErrorHtml(this.formGroup);
      Swal.fire({
        icon: 'warning',
        html: errorHtml,
        confirmButtonText: 'Continuar'
      });
    }
  }

  handleFileReclamo(event: any) {
    if (event.target.files.item(0) != undefined) {
      this.adjuntosevi = event.target.files.item(0);

      let nameFile = this.adjuntosevi.name;
      this.fileNotification = "Ha cargado el siguiente archivo: " + nameFile;
    }
    else {
      this.fileNotification = "Tiene un archivo cargado.";
    }
  }

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  add(complaint: Complaint) {

    this.complaintService.add(complaint).subscribe(async response => {

      if (response.valid) {
        this.matDialog.open(ComplaintResponseComponent, {
          disableClose: true,
          data: {
            complaintNumber: response.data.complaintNumber,
            operationDateTime: new Date(response.data.operationDateTime.toString()),
            operationId: response.data.operationId,
            complaint: this.convertToViewObject(complaint),
            mode: 'complaint',
            isClient: this.isClient
          }
        });
        window.localStorage.removeItem('operationIdGenerate');

      } else {
        if (response.message.startsWith("sesion")) {

          this.formGroup.markAllAsTouched();
          Swal.fire({
            icon: 'warning',
            html: `<h2>Información</h2>
                    <br />
                    <p>Verificamos que ha registrado un reclamo en la presente sesión, le agradecemos revisar las operaciones realizadas.</p>
                    <p>En caso desee registrar un reclamo adicional, salga de la actual sesión y vuelva a conectarse.</p>`,
            confirmButtonText: 'Aceptar'
          }).then(t => {
            if (this.bandera == true || this.authService.IsStandaloneModule()) {
              this.authService.logOut();
            }
            else {
              this.router.navigate(['/ofivirtual']);
            }
          });

        } else if (response.message.startsWith("nocliente")) {
          this.formGroup.markAllAsTouched();
          Swal.fire({
            icon: 'warning',
            html: `<h2>Información</h2>
                    <br />
                    <p>Verificamos que ha registrado un reclamo en la presente sesión, le agradecemos revisar las operaciones realizadas.</p>
                    <p>En caso desee registrar un reclamo adicional, salga de la actual sesión y vuelva a conectarse.</p>`,
            confirmButtonText: 'Aceptar'
          }).then(t => {
            if (this.bandera == true || this.authService.IsStandaloneModule()) {
              // var tab = window.open(returnToUmbraco,'_blank');                       
              this.authService.logOut();
            }
            else {
              this.router.navigate(['/ofivirtual']);
            }
          });

        } else {

          this.formGroup.markAllAsTouched();
          Swal.fire({
            icon: 'warning',
            html: `<h2>Error</h2>
                        <br />
                        <p>`+ response.message + `</p>`,
            confirmButtonText: 'Aceptar'

          }).then(t => {
            // if (this.bandera == true || this.authService.IsStandaloneModule()) {
            //   // var tab = window.open(returnToUmbraco,'_blank'); 
            //   this.authService.logOut();
            // }
            // else {
            //   this.router.navigate(['/ofivirtual']);
            // }
          });
        }
      }
    }, error => {
      this.formGroup.markAllAsTouched();
      Swal.fire({
        icon: 'warning',
        html: `<h2>Error</h2>
                    <br />
                    <p>Se ha producido un error por favor volver a intentar</p>`,
        confirmButtonText: 'Aceptar'

      }).then(t => {
        if (this.bandera == true || this.authService.IsStandaloneModule()) {
          // var tab = window.open(returnToUmbraco,'_blank'); 
          this.authService.logOut();
        }
        else {
          this.router.navigate(['/ofivirtual']);
        }
      });

    });
  }
  // afterClose()
  // {

  // }

  deleteCookies() {
    var cookies = document.cookie.split(";");
    console.log("cookies", cookies)
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = cookies[i] + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  }

  cancel() {
    if (this.bandera == true || this.authService.IsStandaloneModule() && this.isClient == true) {
      this.authService.logOut();
    }
    else if (this.bandera == false && this.authService.IsStandaloneModule() && this.isClient == false) {
      window.location.reload();
      window.location.href = this.environmentService.portalWebUrl + "atencion-al-cliente/reclamos#seccion";
      //Descomentar para producción
      //window.location.href =  this.environmentService.portalWebUrl + "atencion-al-cliente/registrar-reclamos#seccion";  
    }
    else {
      //console.log("bandera",this.bandera)
      this.router.navigate(['/ofivirtual']);
    }
  }

  convertToViewObject(complaint: Complaint) {
    if (this.isClient == true) {
      complaint.client.type = this.clientSectionComponent.clientTypeList.find(x => x.code == this.formGroup.get('client').get('type').value).description;
    }
    else {
      complaint.client.type = this.clientSectionComponent.clientTypeList.find(x => x.code == this.formGroup.get('client').get('typeNoClient').value).description;
    }

    complaint.client.documentType = this.clientSectionComponent.documentTypeList.find(x => x.sapCode == this.formGroup.get('client').get('documentType').value).description;
    if (this.isClient == false && this.send == false) {
      complaint.clientAddress.streetType = ''
      complaint.clientAddress.physicalGroupingType = ''
      complaint.clientAddress.districtCode = ''
      complaint.clientAddress.provinceCode = ''
      complaint.clientAddress.departmentCode = ''
    }

    if (this.isClient == false && this.send == true) {
      complaint.clientAddress.streetType = this.clientAddressSectionComponent.streetTypeList.find(x => x.code == this.formGroup.get('clientAddress').get('streetType').value).description === '' ? " " : this.clientAddressSectionComponent.streetTypeList.find(x => x.code == this.formGroup.get('clientAddress').get('streetType').value).description;
      complaint.clientAddress.physicalGroupingType = this.formGroup.get('clientAddress').get('physicalGroupingType').value === '' ? " " : this.formGroup.get('clientAddress').get('physicalGroupingType').value;
      complaint.clientAddress.districtCode = this.clientAddressSectionComponent.districtList.find(x => x.code == this.formGroup.get('clientAddress').get('districtCode').value).description === '' ? " " : this.clientAddressSectionComponent.districtList.find(x => x.code == this.formGroup.get('clientAddress').get('districtCode').value).description;
      complaint.clientAddress.provinceCode = this.clientAddressSectionComponent.provinceList.find(x => x.code == this.formGroup.get('clientAddress').get('provinceCode').value).description === '' ? " " : this.clientAddressSectionComponent.provinceList.find(x => x.code == this.formGroup.get('clientAddress').get('provinceCode').value).description;
      complaint.clientAddress.departmentCode = this.clientAddressSectionComponent.departmentList.find(x => x.code == this.formGroup.get('clientAddress').get('departmentCode').value).description === '' ? " " : this.clientAddressSectionComponent.departmentList.find(x => x.code == this.formGroup.get('clientAddress').get('departmentCode').value).description;
    }

    if (complaint.clientRepresentative) {
      complaint.clientRepresentative.documentType = this.formGroup.get('representative').get('data').get('documentType').value ? this.clientSectionComponent.documentTypeList.find(x => x.sapCode == this.formGroup.get('representative').get('data').get('documentType').value).description : '';
    }

    if (complaint.secondNotificationAddress) {
      complaint.secondNotificationAddress.districtCode = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('districtCode').value ? this.notificationAddressSectionComponent.districtList.find(x => x.code == this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('districtCode').value).description : '';
    }

    complaint.subReasonCode = this.subReasonList.find(x => x.code === this.formGroup.get('subReason').value).description;
    return complaint;
  }

  buildComplaintObject() {
    //console.log("correo electrónico para enviar",this.emailUser)
    const complaint = new Complaint();
    complaint.client = new ComplaintClient();
    complaint.client.code = this.formGroup.get('client').get('code').value;
    complaint.client.name = this.formGroup.get('client').get('name').value;
    complaint.client.lastName = this.formGroup.get('client').get('lastName').value;
    complaint.client.documentType = this.formGroup.get('client').get('documentType').value;
    complaint.client.documentNumber = this.formGroup.get('client').get('documentNumber').value;
    complaint.client.homePhone = this.formGroup.get('client').get('homePhone').value;
    complaint.client.cellPhone = this.formGroup.get('client').get('cellPhone').value;
    complaint.client.emailAddress = this.formGroup.get('client').get('email').value ? this.formGroup.get('client').get('email').value : this.authService.getUser().emailAddress;
    if (this.isClient == true) {
      complaint.client.type = this.formGroup.get('client').get('type').value;
      complaint.indicadorTitular = '01';
    }
    else {
      complaint.client.type = this.formGroup.get('client').get('typeNoClient').value;
    }

    complaint.client.interlocutorId = this.formGroup.get('client').get('interlocutorId').value;
    complaint.client.installationNumber = this.formGroup.get('client').get('installationNumber').value;
    complaint.clientAddress = new ComplaintAddress();

    if (this.isClient == false) {
      complaint.clientAddress.streetType = this.formGroup.get('clientAddress').get('streetType').value;
      complaint.clientAddress.streetDescription = this.formGroup.get('clientAddress').get('streetDescription').value;
      complaint.clientAddress.streetNumber = this.formGroup.get('clientAddress').get('streetNumber').value;
      complaint.clientAddress.buildingType = this.formGroup.get('clientAddress').get('buildingType').value;
      complaint.clientAddress.buildingDescription = this.formGroup.get('clientAddress').get('buildingDescription').value;
      complaint.clientAddress.interiorType = this.formGroup.get('clientAddress').get('interiorType').value;
      complaint.clientAddress.interiorDescription = this.formGroup.get('clientAddress').get('interiorDescription').value;
      complaint.clientAddress.physicalGroupingType = this.formGroup.get('clientAddress').get('physicalGroupingType').value;
      complaint.clientAddress.physicalGroupingDescription = this.formGroup.get('clientAddress').get('physicalGroupingDescription').value;
      complaint.clientAddress.virtualGroupingType = this.formGroup.get('clientAddress').get('virtualGroupingType').value;
      complaint.clientAddress.virtualGroupingDescription = this.formGroup.get('clientAddress').get('virtualGroupingDescription').value;
      complaint.clientAddress.block = this.formGroup.get('clientAddress').get('block').value;
      complaint.clientAddress.lot = this.formGroup.get('clientAddress').get('lot').value;
      complaint.clientAddress.districtCode = this.formGroup.get('clientAddress').get('districtCode').value;
      complaint.clientAddress.provinceCode = this.formGroup.get('clientAddress').get('provinceCode').value;
      complaint.clientAddress.departmentCode = this.formGroup.get('clientAddress').get('departmentCode').value;
      complaint.clientAddress.houseFloorNumber = this.formGroup.get('clientAddress').get('houseFloorNumber').value;

      complaint.clientAddress.districtDescription = this.clientAddressSectionComponent.districtList.find(x => x.code == this.formGroup.get('clientAddress').get('districtCode').value).description;
      complaint.clientAddress.provinceDescription = this.clientAddressSectionComponent.provinceList.find(x => x.code == this.formGroup.get('clientAddress').get('provinceCode').value).description;
      complaint.clientAddress.departmentDescription = this.clientAddressSectionComponent.departmentList.find(x => x.code == this.formGroup.get('clientAddress').get('departmentCode').value).description;

      complaint.clientAddress.region = this.clientAddressSectionComponent.districtList.find(x => x.code === complaint.clientAddress.districtCode).region === '' ? " " : this.clientAddressSectionComponent.districtList.find(x => x.code === complaint.clientAddress.districtCode).region;
      complaint.clientAddress.postalCode = this.clientAddressSectionComponent.districtList.find(x => x.code === complaint.clientAddress.districtCode).postalCode === '' ? " " : this.clientAddressSectionComponent.districtList.find(x => x.code === complaint.clientAddress.districtCode).postalCode;
    }
    complaint.firstNotificationAddress = this.formGroup.get('notificationAddress').get('firstNotificationAddress').value;

    if (this.formGroup.get('notificationAddress').get('includeSecondNotificationAddress').value == true) {
      complaint.secondNotificationAddress = new ComplaintSimpleAddress();
      complaint.secondNotificationAddress.description = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('description').value;
      complaint.secondNotificationAddress.districtCode = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('districtCode').value;
      complaint.secondNotificationAddress.provinceCode = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('provinceCode').value;
      complaint.secondNotificationAddress.reference = this.formGroup.get('notificationAddress').get('secondNotificationAddress').get('reference').value;
    }
    complaint.emailAddressNotification = new EmailNotification();
    complaint.emailAddressNotification.indContrastacion = this.contrastConfirm == true ? this.isContrast = "SI" : this.isContrast = "NO";
    complaint.emailAddressNotification.operRegLectura = "0";
    //Validacion serí­a si existe
    complaint.emailAddressNotification.indNotifElectronica = this.isEmailNotificaction;
    //console.log("correo electrónico enviado",this.emailUser)
    complaint.emailAddressNotification.emailNotifElec = this.emailUser;

    if (this.formGroup.get('representative').get('includeRepresentativeSection').value == true) {
      complaint.clientRepresentative = new ComplaintClientRepresentative();
      complaint.clientRepresentative.name = this.formGroup.get('representative').get('data').get('name').value;
      complaint.clientRepresentative.lastName = this.formGroup.get('representative').get('data').get('lastName').value;
      complaint.clientRepresentative.documentNumber = this.formGroup.get('representative').get('data').get('documentNumber').value;
      complaint.clientRepresentative.documentType = this.formGroup.get('representative').get('data').get('documentType').value;
      complaint.clientRepresentative.homePhone = this.formGroup.get('representative').get('data').get('homePhone').value;
      complaint.clientRepresentative.cellPhone = this.formGroup.get('representative').get('data').get('cellPhone').value;
      complaint.clientRepresentative.emailAddress = this.formGroup.get('representative').get('data').get('email').value;
      complaint.clientRepresentative.relationshipType = this.formGroup.get('representative').get('data').get('relationshipType').value;
      complaint.indicadorTitular = complaint.clientRepresentative.relationshipType;
    }
    //console.log("datos del representante enviados al servicio", complaint.clientRepresentative)
    complaint.subReasonCode = this.formGroup.get('subReason').value;
    complaint.description = this.formGroup.get('description').value + '--->' + complaint.firstNotificationAddress;

    let operationIdGenerate = window.localStorage.getItem('operationIdGenerate');
    if (operationIdGenerate != null) {
      complaint.description += " - NroRegistroLectura: " + operationIdGenerate;
    }

    complaint.email = new Email();
    complaint.email.addressList = [
      this.formGroup.get('client').get('email').value ? this.formGroup.get('client').get('email').value : this.authService.getUser().emailAddress];
    if (this.showBillSection) {
      const bill = new ComplaintBill();
      bill.number = this.formGroup.get('bill').get('number').value;
      bill.period = this.monthList.find(x => x.code === this.formGroup.get('bill').get('month').value).description + ' ' + this.formGroup.get('bill').get('year').value;
      bill.currency = 'PEN';
      // let totalAmount = 0;
      // bill.itemList = this.billItemList.filter(x => x.checked)
      //   .map((item) => {
      //     totalAmount = totalAmount + parseFloat(item.data.amount);
      //     return item.data.formattedValue;
      //   });

      let prepare: any = [];
      for (let i = 0; i < this.listToSend.length; i++) {
        prepare.push(this.listToSend[i].Import)
      }
      let totalAmount = prepare.map(c => parseFloat(c)).reduce((a, b) => a + b, 0);
      let rounded = parseFloat(totalAmount).toFixed(2);

      bill.totalAmount = rounded.toString();
      complaint.billList = [bill];
      const conceptBlocking = new ComplaintConcept();
      conceptBlocking.InterloculorComercial = "0";
      conceptBlocking.NroDocumentoOficial = "0";
      conceptBlocking.Anno = "0";
      conceptBlocking.Mes = "0";
      conceptBlocking.FechaEmision = "0";
      conceptBlocking.FechaVencimiento = "0";
      conceptBlocking.CodConcepto = "0";
      conceptBlocking.DesConcepto = "0";
      conceptBlocking.Importe = "0";

      let list: string[] = [];
      for (let i = 0; i < this.listToSend.length; i++) {
        list.push(this.listToSend[i].Locutor
          + "||" + this.listToSend[i].documentNumber
          + "||" + this.listToSend[i].Year
          + "||" + this.listToSend[i].Month
          + "||" + this.listToSend[i].Date
          + "||" + this.listToSend[i].DateHist
          + "||" + this.listToSend[i].ConceptCode
          + "||" + this.listToSend[i].DesConcept
          + "||" + this.listToSend[i].Import
          + "||" + this.listToSend[i].Moneda);
      }

      conceptBlocking.itemList = list;

      //conceptBlocking.itemList = [||];
      let interloc = this.formGroup.get('client').get('interlocutorId').value;

      let docNumber = this.formGroup.get('client').get('documentNumber').value;

      complaint.ComplaintConcepto = [conceptBlocking];

      complaint.isAcceptTerms = this.isAcceptTerms;
    }
    return complaint;
  }
}